export const contactInitialState = {
  title: '',
  dateOfBirth: '',
  phone: '',
  cellPhone: '',
  contacted: '',
  receiveCommercialInformation: ''
}
